import { Directive, Input, Output, HostListener, EventEmitter, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[menu]'
})
export class MenuDirective {

    private _open:boolean;
    private _timer:any;

    constructor() {
    }

    @Input()
    private set menu(value:boolean) {
        this._open = value ? value : false;
    }

    @Output() onClose:EventEmitter<any> = new EventEmitter();

    @HostListener('mouseleave')
    onMouseLeave() {
        if (!this._open)
            return;
        this._timer = setTimeout(() => {
            this.onClose.emit(true);
            this.closeMenu();
        }, 500);
    }

    @HostListener('mouseenter')
    onMouseEnter() {
        clearTimeout(this._timer);
    }

    ngOnChanges(changes:SimpleChanges){
        if(changes.menu.previousValue){
            this._open = changes.menu.currentValue;
        }
    }

    public openMenu() {
        this._open = true;
    }

    public closeMenu() {
        this._open = false;
        clearTimeout(this._timer);
    }

}



// WEBPACK FOOTER //
// ./src/directives/menu/menu.ts